import * as Sentry from "@sentry/react";

function sentryReportingActive(): boolean {
  return Boolean(
    import.meta.env.VITE_SENTRY_DSN &&
      (import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === "true"),
  );
}

/** Sends to Sentry only when the client SDK is configured (matches `src/instrument.ts`). */
export function captureClientException(
  error: unknown,
  captureContext?: Sentry.CaptureContext,
): void {
  if (!sentryReportingActive()) return;
  Sentry.captureException(
    error instanceof Error ? error : new Error(String(error)),
    captureContext,
  );
}

/** User id only (no email) — matches Sentry `sendDefaultPii: false`. */
export function syncSentryUser(userId: string | null): void {
  if (!sentryReportingActive()) return;
  if (userId) Sentry.setUser({ id: userId });
  else Sentry.setUser(null);
}
